import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import * as globals from "./globals";
import { User, Rule, Setting, Notification, Role, CalendarEntry } from './classes';
import { Observable, Subject } from 'rxjs';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { TokenService } from "./lib/shared/services/token.service";

/**
 * @deprecated this service should not longer be used
 */
@Injectable({
    providedIn: 'root'
})
export class BackEndService {

    userIsAdmin: boolean = false;
    user: User = null;
    userRoles: Role[] = [];

    _rights: Rule[] = [];
    set rights(value) {
        this._rights = value;
        this.rightsChanged.next();
    }
    get rights(): Rule[] {
        return this._rights;
    }
    rightsChanged: Subject<void> = new Subject();

    settings: Setting[] = [];
    backgroundColor: Setting = null;
    nextcloudUsername: Setting = null;
    mainNewsfeedIdentifier: Setting;
    mainNewsfeedWidth: Setting;
    zoomLevel: Setting = {
        "stgname": "zoom_level",
        "stgvalue": "80"
    } as Setting;
    userIsLoaded: boolean = false;

    loginAnchor: Subject<User> = new Subject();
    logoutAnchor: Subject<any> = new Subject();
    progressAnchor: Subject<number> = new Subject();
    newsfeedRefreshAnchor: Subject<void> = new Subject();
    newsfeedDeleteAnchor: Subject<void> = new Subject();
    newsfeedCreateAnchor: Subject<void> = new Subject();

    sessionErrors: Notification[] = [];
    sessionErrorsAnchor: Subject<void> = new Subject();

    constructor(
        private client: HttpClient,
        private _router: Router,
        private _tokenService: TokenService
    ) { }

    addError(error: HttpErrorResponse) {
        var desc = "Fehler: " + error.status;
        switch (error.status) {
            case 401:
                desc = "Fehler: Unauthorisiert/ nicht angemeldet";
                break;
            case 403:
                desc = "Fehler: Berechtigungsfehler";
                break;
            case 404:
                desc = "Fehler: Element wurde nicht gefunden";
                break;
            case 409:
                desc = "Fehler: Nextcloudverbindung fehlgeschlagen";
                break;
        }
        this.sessionErrors.push({
            "notificationseen": null,
            "notificationsubject": desc,
            "notificationtext": (error.message) + ": " + error.error,
            "notificationtime": moment().format("YYYY-MM-DDTHH:mm:ss")
        } as Notification);
        this.sessionErrorsAnchor.next();
    }

    assignUser(issueId: number, userId: string): Observable<any> {
        return this.get("api/issue/" + issueId + "/assign/" + userId);
    }
    /**
     * the method creates a nextcloud calendar event
     */
    createEvent(event: CalendarEntry): Observable<any> {
        return this.post("api/nextcloud/calendar/event", {
            id: event.id,
            title: event.title,
            start: moment(event.start).format("YYYYMMDDTHHmmss"),
            end: moment(event.end).format("YYYYMMDDTHHmmss"),
            href: event.href
        } as CalendarEntry);
    }
    /**
     * the method sends a http delete to the backend
     */
    delete(url) {
        return this.client.delete(globals.serverLocation + "/" + url, {
            headers: new HttpHeaders().set("Authorization", "Bearer " + this._tokenService.token)
        });
    }
    /**
     * the method sends a http get request to the backend
     */
    get(url) {
        return this.client.get(globals.serverLocation + "/" + url, {
            headers: new HttpHeaders().set("Authorization", "Bearer " + this._tokenService.token)
        });
    }
    /**
     * the method sends a http get request to the backend
     */
    getBlob(url) {
        return this.client.get(globals.serverLocation + "/" + url, {
            headers: new HttpHeaders().set("Authorization", "Bearer " + this._tokenService.token),
            responseType: 'blob'
        });
    }
    /**
     * the method returns whether the current user is allowed for all the given rule codes
     */
    isAllowedAND(rules: string[]) {
        if (typeof (this.rights.find(x => x.rulecode == "edit_datasets")) != "undefined") return true;
        for (let rule of rules) {
            if (typeof (this.rights.find(x => x.rulecode == rule)) == "undefined") return false;
        }
        return true;
    }
    /**
     * the method returns whether the current user is allowed for all the given rule codes
     */
    isAllowedOR(rules: string[]) {
        if (typeof (this.rights.find(x => x.rulecode == "edit_datasets")) != "undefined") return true;
        for (let rule of rules) {
            if (typeof (this.rights.find(x => x.rulecode == rule)) != "undefined") return true;
        }
        return false;
    }
    /**
     * the method initiates a put request to the backend
     */
    put(url, data) {
        return this.client.put(globals.serverLocation + "/" + url, data, {
            headers: new HttpHeaders().set("Authorization", "Bearer " + this._tokenService.token)
        });
    }
    /**
     * the method initiates a post request to the backend
     */
    post(url, data) {
        return this.client.post(globals.serverLocation + "/" + url, data, {
            headers: new HttpHeaders().set("Authorization", "Bearer " + this._tokenService.token)
        });
    }

    /**
     * the method sends a http get request to the backend
     */
    postToBlob(url, data) {
        return this.client.post(globals.serverLocation + "/" + url, data, {
            headers: new HttpHeaders().set("Authorization", "Bearer " + this._tokenService.token),
            responseType: "blob"
        });
    }

    requestOO(data) {
        let headers: HttpHeaders = new HttpHeaders();
        headers = headers.append("Accept", "*/*");
        headers = headers.append("Authorization", "Bearer " + this._tokenService.token);
        return this.client.post(globals.serverLocation + "/api/nextcloud/file/oo", data, {
            headers: headers
        });
    }
}